export type NotificacaoEnviadaModel = {
    id: number
    titulo: string
    mensagem: string
    tipo: string
    quantidade: number
    dataInicio: string | null
}

export type NotificacaoAgendadaModel = {
    id: number
    titulo: string
    mensagem: string
    quantidade: number
    dataInicio: string | null
}

export type FiltroNotificacoes = {
    dataInicio: string
    dataFim: string
    titulo: string
}

export type VerNotificacoesFornecedorModel = {
    listaEnviadas: NotificacaoEnviadaModel[]
    listaAgendadas: NotificacaoAgendadaModel[]
    filtro: FiltroNotificacoes
}

function hoje(): string {
    return new Date().toISOString().split("T")[0]
}

export const VerNotificacoesFornecedorInicial: VerNotificacoesFornecedorModel = {
    listaEnviadas: [],
    listaAgendadas: [],
    filtro: {
        dataInicio: hoje(),
        dataFim: hoje(),
        titulo: "",
    },
}
